export enum postcodeTypes {
  FETCH_POSTCODE_REQUEST = "FETCH_POSTCODE_REQUEST",
  FETCH_POSTCODE_SUCCESS = "FETCH_POSTCODE_SUCCESS",
  FETCH_POSTCODE_FAILURE = "FETCH_POSTCODE_FAILURE",
  FETCH_OPENAI_REQUEST = "FETCH_OPENAI_REQUEST"
}